/**
 * Text and textarea field formatters
 */

export const textDisplayFormatter = (value) => {
  if (value === null || value === undefined || value === '') return '-';
  return value;
};

export const textExifFormatter = (value) => value?.trim() || null;

export const textFromExifFormatter = (value) => value || '';

export const textareaFromExifFormatter = (value) => {
  // UserComment has special encoding, may need cleanup
  if (typeof value === 'string') return value.replace(/^\x00+/, '').trim() || '';
  return value || '';
};

/**
 * Returns standard text field formatters
 */
export function getTextFormatters(options = {}) {
  const { defaultValue = '' } = options;
  return {
    formatForDisplay: textDisplayFormatter,
    formatForExif: textExifFormatter,
    formatFromExif: textFromExifFormatter,
    defaultValue
  };
}

/**
 * Returns textarea field formatters with optional special fromExif handling
 */
export function getTextareaFormatters(options = {}) {
  const { specialFromExif = false, defaultValue = '' } = options;
  return {
    formatForDisplay: textDisplayFormatter,
    formatForExif: textExifFormatter,
    formatFromExif: specialFromExif ? textareaFromExifFormatter : textFromExifFormatter,
    defaultValue
  };
}
